<script lang="ts">
    import RewardsIconButton from "@apps/rewards/components/Buttons/RewardsIconButton.svelte";
    import RewardsIcon from "@apps/rewards/components/RewardsIcon.svelte";

    import type { EmblaSliderApi } from "@components/Slider/types";

    import SliderLeftArrowIcon from "../widgets/rewards_page_widgets/widgets/rewards_vip_tiers_page_widget/components/icons/SliderLeftArrowIcon.svelte";
    import SliderRightArrowIcon from "../widgets/rewards_page_widgets/widgets/rewards_vip_tiers_page_widget/components/icons/SliderRightArrowIcon.svelte";

    export let perPage: number;
    export let slidesCount: number;
    export let sliderApi: EmblaSliderApi | undefined;
    export let currentIndex: number | undefined;
    export let onPrev: () => void;
    export let onNext: () => void;
    export let prevButtonAriaLabel: string;
    export let nextButtonAriaLabel: string;

    let hasPrev = false;
    let hasNext = false;

    $: {
        currentIndex;

        if (sliderApi) {
            hasPrev = sliderApi.canScrollPrev() || false;
            hasNext = sliderApi.canScrollNext() || false;
        }
    }
</script>

{#if slidesCount > perPage}
    <div class="gw-rd-slider-arrows">
        <div class:active={hasPrev}>
            <RewardsIconButton
                on:click={onPrev}
                ariaLabel={prevButtonAriaLabel}
            >
                <RewardsIcon isBrandingIconColor={false}>
                    <SliderLeftArrowIcon />
                </RewardsIcon>
            </RewardsIconButton>
        </div>
        <div class:active={hasNext}>
            <RewardsIconButton
                on:click={onNext}
                ariaLabel={nextButtonAriaLabel}
            >
                <RewardsIcon isBrandingIconColor={false}>
                    <SliderRightArrowIcon />
                </RewardsIcon>
            </RewardsIconButton>
        </div>
    </div>
{/if}

<style lang="postcss">
    .gw-rd-slider-arrows {
        display: flex;
        justify-content: end;
        gap: var(--gw-rd-space-4);
        margin-bottom: var(--gw-rd-space-3);
        color: #98a2b3;

        @media (width < 1000px) {
            display: none;
        }

        :global(.gw-btn.gw-rd-icon-btn) {
            padding: var(--gw-rd-space-2);
            border-radius: var(--gw-rd-border-radius-xs);
            background-color: hsl(0, 0%, 98%);
            transition: background-color 0.2s ease-in-out;

            &:hover {
                background-color: var(--gw-rd-page-lightgrey-color);
            }
        }

        .active {
            color: #3c3c3c;
        }
    }
</style>
